/*@flow*/
/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { createRef } from 'react';
import DotCount from './LocationToolbar/DotCount';
import GeolocateBtn from 'comps/GeolocateBtn';
import useBboxBoundAutoComplete from 'lib/useBboxBoundAutoComplete';

function SearchAddress() {
  const ref = createRef();
  useBboxBoundAutoComplete(ref);

  return (
    <div data-testid="SearchAddress">
      <div
        css={css(`
        .btn {
          background: transparent !important;
          border: none !important;
        }
        display: flex;
        align-items: center;
        padding-left: 0.5rem;
        background: white;
        border: solid 1px #ccc;
        border-radius: 8px;
      `)}
      >
        <GeolocateBtn />
        <input
          data-testid="SearchAddress"
          placeholder="Search an address"
          autoComplete="off"
          className="form-control form-control-lg"
          type="search"
          ref={ref}
          css={css(`
            padding: 3px 7px 5px 5px !important;
            margin-bottom: 0px;
            height: initial;
            display: inline-block;
            width: 100%;
            background: none !important;
            border: none !important;
            font-size: 1.4rem;
            line-height: 2.2rem;
            color: #999;
            &:focus {
              color: #333;
            }
        `)}
        />
      </div>
      <div className="d-flex justify-content-end mt-2">
        <DotCount />
      </div>
    </div>
  );
}

export default (SearchAddress: any);
